export class AutoPatrocinio {
    iD_PESSOA : number;
    iD_PLANO : number;
    iD_CONTRIBUICAO : number;
    iD_MODO_PAG_REC : number;
    iC_COBRA : string;
    iC_RESP_FINANC : string;
}